import { QRCodeSVG } from "qrcode.react";
import { forwardRef } from "react";
import { useBrandLogo } from "../../lib/brandAssets";

const QRCard = forwardRef(function QRCard({
  kind = "visit",
  qrToken,
  refCode,
  title = "SCAN. REGISTER. ENJOY.",
  subtitle,
  badgeLabel,
  perks = [],
  footerLine = "MOBILE FRIENDLY",
  date,
  testId,
  svgId,
}, ref) {
  const logo = useBrandLogo();

  return (
    <div
      ref={ref}
      className="qr-frame relative max-w-md mx-auto p-6 sm:p-8 rounded-md text-center"
      data-testid={testId || "qr-card"}
      style={{ background: "#050505" }}
    >
      <div className="flex flex-col items-center gap-2">
        <img src={logo} alt="" className="h-16 w-16 rounded-full ring-1 ring-[#D4AF37]/40" />
        <p className="font-display text-2xl text-white leading-tight tracking-wide">THE SOCIAL CIRCLE</p>
        <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">by Cornerstone</p>
      </div>

      <div className="mt-5 mb-2">
        <p className="font-display text-2xl sm:text-3xl text-white leading-tight">{title}</p>
        {subtitle && <p className="mt-1 text-white/70 text-sm">{subtitle}</p>}
      </div>

      {badgeLabel && (
        <div className="my-4 inline-block bg-gold-gradient text-black font-semibold tracking-luxe text-xs px-5 py-2 rounded-full">
          {badgeLabel}
        </div>
      )}

      <div className="bg-white p-4 rounded-md mx-auto inline-block mt-3 mb-4">
        <QRCodeSVG
          id={svgId}
          value={qrToken || ""}
          size={260}
          bgColor="#ffffff"
          fgColor="#000000"
          level="M"
          includeMargin={true}
        />
      </div>

      {refCode && (
        <p className="font-mono text-[#D4AF37] tracking-[0.3em] text-sm mt-1" data-testid="qr-ref-code">
          {refCode}
        </p>
      )}

      <div className="mt-3 inline-block bg-black border border-[#D4AF37]/40 text-white/80 text-[10px] tracking-luxe px-3 py-1 rounded-full">
        {footerLine}
      </div>

      {perks?.length > 0 && (
        <ul className="mt-5 grid gap-1.5 text-left">
          {perks.map((p, i) => (
            <li key={i} className="text-white/70 text-xs flex items-start gap-2">
              <span className="text-[#D4AF37] mt-[2px]">◆</span>{p}
            </li>
          ))}
        </ul>
      )}

      {date && (
        <p className="mt-4 text-[10px] tracking-luxe uppercase text-white/40">{date}</p>
      )}

      <div className="mt-6 flex items-center justify-center gap-2">
        <div className="h-px w-10 bg-[#D4AF37]/40" />
        <div className="h-1.5 w-1.5 rounded-full bg-[#D4AF37]" />
        <div className="h-px w-10 bg-[#D4AF37]/40" />
      </div>

      <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]/80 mt-2">
        {kind === "member" ? "Member Privileges Card" : "Official Partner Visit Code"}
      </p>
    </div>
  );
});

export default QRCard;
